/*
* Copyright (c) 2014-2023 Inovalon, Inc. All Rights Reserved.
* This computer program is CONFIDENTIAL and a TRADE SECRET of Inovalon, Inc.
* The receipt or possession of this program does not convey any rights to use, reproduce or disclose
* its contents in whole or in part, without the specific written consent of Inovalon, Inc.
* Any use, reproduction or disclosure of this program without the express written consent of Inovalon, Inc.
* is a violation of the copyright laws and may subject you to criminal prosecution.
*/
import React from 'react'
import './CEligibilitySummary.scss'
import { ICoverageDiscoveryResponseStateManager, IBaseSection, ICEligibilitySummary, ICEligibilitySummaryIdentifiers } from '../../../../services/CoverageDiscoveryResponseStateManager/contracts'
import { observer } from 'mobx-react'
import parse from 'html-react-parser'
import { CommonUtils } from '../../../../utils/CommonUtils'
import { EligibilityStatus } from '../../../../configuration/Enums/EligibilityStatus'
import { renderToString } from 'react-dom/server'

export interface ICEligibilitySummaryProps {
	CoverageDiscoveryResponseStateManager: ICoverageDiscoveryResponseStateManager
}

@observer
export class CEligibilitySummary extends React.Component<ICEligibilitySummaryProps> {
	private readonly dateFormat = 'MM/DD/YYYY'

	renderHeader(model: IBaseSection): JSX.Element {
		if (!model.cEligibilitySummary || !model.cEligibilitySummary.eligibilitySummaryStatus) {
			return <h3>Eligibility Summary</h3>
		} else {
			// eslint-disable-next-line @typescript-eslint/no-var-requires
			const image: JSX.Element = <img alt="CEligibilitySummary" src={require('../../../../img/Eligibility/' + model.cEligibilitySummary.eligibilitySummaryStatus.largeImage).default} className="eligibility-summary-title-image" />
			const activeResponseEligibility = this.props.CoverageDiscoveryResponseStateManager.activeResponseEligibility
			const statusDescription = model.cEligibilitySummary.eligibilitySummaryStatus.description
			const toolTip = model.cEligibilitySummary.eligibilitySummaryStatus.toolTip
			return (
				<>
					<h3 className="eligibility-summary-title" title={toolTip}>
						Eligibility Summary: {statusDescription}
					</h3>
					{image}
				</>
			)
		}
	}

	renderBody(model: ICEligibilitySummary): JSX.Element | null {
		const hasSubName = model.eligibilityResponse.subscriber.dependent && model.eligibilityResponse.subscriber.dependent.lastName && model.eligibilityResponse.subscriber.dependent.lastName.trim() !== ''
		const contentSubscriberName = hasSubName && (
			<tr>
				<td className="bottom-border-td">Subscriber Name:</td>
				<td colSpan={3} className="bottom-border-td">
					{model.eligibilityResponse.subscriber.firstName}-{model.eligibilityResponse.subscriber.lastName}
				</td>
			</tr>
		)

		let network = ''
		let index = 1
		if (model.planNetwork && model.planNetwork.length > 0) {
			model.planNetwork.forEach(element => {
				network += index === 1 ? 'Network:' + element : ',' + element
				index++
			})
		}
		const hasPlanNameOrEffDate = model.planName || model.effectiveDate
		const contentPlanNameEffectiveDate = hasPlanNameOrEffDate && (
			<tr>
				<td className="bottom-border-td">Plan Name:</td>
				<td className="bottom-border-td">
					{model.planName} <br /> {network}
				</td>
				<td className="bottom-border-td">Effective Date:</td>
				<td className="bottom-border-td">{model.effectiveDate}</td>
			</tr>
		)

		if (!hasSubName && !hasPlanNameOrEffDate) {
			return null
		} else
			return (
				<>
					{contentSubscriberName}
					{contentPlanNameEffectiveDate}
				</>
			)
	}

	renderBodySubSection(identifiers: ICEligibilitySummaryIdentifiers[]): string | undefined {
		let result = ''
		let row = 1
		identifiers.forEach(element => {
			if (row % 2 === 1) {
				result += '<tr>'
			}
			result += '<td class="bottom-border-td">' + element.item1 + '</td>'
			result += '<td class="bottom-border-td">' + element.item2 + '</td>'
			if (row % 2 === 0) {
				result += '</tr>'
			}
			row++
		})
		if (result.length > 0 && row % 2 === 0) {
			result += '<td class="bottom-border-td"></td><td class="bottom-border-td"></td></tr>'
		}
		if (result.length > 0) {
			return result
		}
	}

	render(): React.ReactNode {
		const cEligibilitySection = this.props.CoverageDiscoveryResponseStateManager.selectedCEligibilitySection

		if (cEligibilitySection && cEligibilitySection.cEligibilitySummary) {
			const model = cEligibilitySection.cEligibilitySummary
			const styleClass = cEligibilitySection.cEligibilitySummary.eligibilitySummaryStatus ? cEligibilitySection.cEligibilitySummary.eligibilitySummaryStatus.classColor : 'eligibility-summary status-active'

			const header = this.renderHeader(cEligibilitySection)
			const body = this.renderBody(cEligibilitySection.cEligibilitySummary)
			const container = `<table class="${styleClass}"><thead><tr><th colspan="4">${renderToString(header)}</th></tr></thead>${body || (model.identifiers && model.identifiers.length > 0) ? `<tbody>${body ? renderToString(body) : ``}${model.identifiers && model.identifiers.length > 0 ? this.renderBodySubSection(model.identifiers) : ``}</tbody>` : ``}</table>`
			return <div className="cdResponsePage">{parse(container)}</div>
		} else {
			return <></>
		}
	}
}
